import interceptorAxios from './InterceptorAxios';
const ServicioCancelacion = {
    cancelar_cfdis(objeto){
        return interceptorAxios.post('cancelacion/cancelar_cfdis.json',objeto);
    },
    reexpedir_cfdis(objeto){
        return interceptorAxios.post('cancelacion/reexpedir_cfdi.json',objeto);
    }
}
export default ServicioCancelacion;